// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * core-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BankAPIModel
 */
export interface BankAPIModel {
    /**
     * 
     * @type {string}
     * @memberof BankAPIModel
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BankAPIModel
     */
    name: string;
}

export function BankAPIModelFromJSON(json: any): BankAPIModel {
    return BankAPIModelFromJSONTyped(json, false);
}

export function BankAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): BankAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function BankAPIModelToJSON(value?: BankAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}


